<template> 
<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{templateName}}</h2>
    </div>
    <div class="col-lg-2">
      <span class="tooltip-wrapper pointer" style="float:right">
       <i class="fa fa-times close" @click="onclosed()"></i>
       <span class="custom-tooltip closetooltipposition">Close</span>
  </span>
       
    </div>
  </div>
<div class="wrapper wrapper-content">
    <dynamicform
    :templateid = "tempId"
    :requiredvalidate = 'false'
    :requiredsubmit = 'false'
    :requiredrole=requiredRole
    :requiredlanguage = 'true'
    :skipcheckingdependency="true"
    />
</div>
</template>

<script src="./viewTemplateComponent.js"></script>
<style scoped>

.closetooltipposition{
  bottom: -10px !important;
  margin-left: -75px !important;
}


</style>